import { reactive } from "vue";

export const modalTypes = {
  country: "country",
  basin: "basin",
  crop: "crop",
  scenario: "scenario",
  scenario1: "scenario1",
  scenarioCountryCrop: "scenarioCountryCrop",
  scenarioProcess: "scenarioProcess",
  process: "process"
};

let modalId = 5;

const modalModel = reactive({
  modals: []
});

export const modals = modalModel.modals;

export function openModal(type, params) {
  modals.push(Object.assign({ id: modalId++ }, params, { type }));
}

export function closeModal(modal) {
  modals.splice(modals.indexOf(modal), 1);
}